<template>
  <div>123</div>
</template>
<script>

export default {
  name: "focus",
  props: {},
//   components: { List, Popup },
};
</script>
